module.exports = __webpack_public_path__ + "img/智驹-APP介绍-中文_2_09.cf5e9cd2.jpg";